import './index.scss'

const LoadingViewContainer = () => <div className="loading-view" />

export default LoadingViewContainer
